<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Sửa Lead</h1>
      <div class="btn-group float-right">
        <button type="button" class="btn font-medium btn-outline-secondary" @click="updateLead()">
          <i class="bx bx-save"></i> Lưu danh bạ
        </button>
        <button
          type="button"
          class="btn font-medium btn-outline-secondary"
          @click="convertIntoCustomer(true)"
        >
          <i class="bx bx-user-plus"></i> Chuyển thành KH
        </button>
        <button
          type="button"
          class="btn font-medium btn-outline-secondary"
          @click="checkCloseAdd()"
        >
          <i class="bx bx-exit"></i> Hủy bỏ
        </button>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <ValidationObserver ref="leadsEdit" class="card-body px-20 mt-2 row">
        <form class="col-md-6">
          <h1 class="form-inner-heading mb-1">Thông tin</h1>

          <div class="form">
            <ValidationProvider
              rules="required|minMaxName_2"
              vid="merchantName"
              name="Tên cửa hàng"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label"
                  >Tên merchant <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.merchantName"
                    type="text"
                    class="form-control"
                    placeholder="Tên cửa hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" vid="cityCode" name="Tỉnh/Thành phố">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Tỉnh/Thành phố <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.cityCode"
                    :options="dataProvince"
                    @select="getNameProvince($event)"
                    placeholder="Tỉnh/Thành phố"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <div class="form-group row">
              <label for class="col-sm-3 col-form-label">Quận/huyện</label>
              <div class="col-sm-7">
                <Select2
                  v-model="dataAdd.districtCode"
                  :options="dataDistrict"
                  @select="getNameDistrict($event)"
                  placeholder="Quận/Huyện"
                />
              </div>
            </div>

            <ValidationProvider rules="minMaxName_2" vid="address" name="Địa chỉ">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Địa chỉ</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.address"
                    type="text"
                    class="form-control"
                    placeholder="Địa chỉ"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="phoneLimit" vid="mobile" name="Số điện thoại">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Số điện thoại <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.mobile"
                    type="text"
                    class="form-control"
                    placeholder="Số điện thoại"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="mail_2" vid="email" name="Email">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Email</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.email"
                    type="text"
                    class="form-control"
                    placeholder="Email"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Tên biển hiệu</label>
              <div class="col-sm-7">
                <input
                  v-model="dataAdd.storeSignName"
                  type="text"
                  class="form-control"
                  placeholder="Tên biển hiệu"
                />
              </div>
            </div>

            <ValidationProvider rules="minMaxName_2" vid="customerName" name="Tên người đại diện">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label">Tên người đại diện</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.customerName"
                    type="text"
                    class="form-control"
                    placeholder="Họ tên"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <div class="form">
            <ValidationProvider rules="" vid="customerType" name="Loại khách hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label">Loại hình</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.customerType"
                    :options="dataCustomerType"
                    placeholder="Loại khách hàng"
                    :class="{
                      'invalid-form': dataAdd.customerType === '' || dataAdd.customerType === null,
                    }"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="mcc" name="Ngành nghề">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Ngành nghề</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.mcc"
                    :options="systemConfig.businessFields"
                    placeholder="Ngành nghề"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider v-if="dataAdd.mcc" vid="mccDetail" name="Ngành nghề chi tiết">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Ngành nghề chi tiết</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.mccDetail"
                    :options="getMccDetail(dataAdd.mcc)"
                    placeholder="Ngành nghề chi tiết"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="dataAdd.mccDetail === 'Khác'"
              vid="numberOfShop"
              name="Ngành nghề chi tiết(Ghi chú thêm)"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Ngành nghề chi tiết(Ghi chú thêm)</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.mccDetailOther"
                    placeholder="Ngành nghề chi tiết(Ghi chú thêm)"
                    type="text"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="mcc" name="Có GPDKKD không">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Có GPDKKD không</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.licenseBusiness"
                    :options="systemConfig.licenseBusiness"
                    placeholder="Có GPDKKD không"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <div class="form">
            <ValidationProvider vid="mcc" name="Vị trí cửa hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Vị trí cửa hàng</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.storeLocation"
                    :options="systemConfig.storeLocation"
                    placeholder="Vị trí cửa hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="mcc" name="Giá trị đơn hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Giá trị đơn hàng</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.averageOrder"
                    :options="systemConfig.averageOrder"
                    placeholder="Giá trị đơn hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="mcc" name="Người mua hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Người mua hàng</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.averageAge"
                    :options="systemConfig.averageAge"
                    placeholder="Người mua hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="numberOfShop" name="Số lượng cửa hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Số lượng cửa hàng</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.extraInfo.numberOfShop"
                    type="number"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="numberOfStaff" name="Số lượng nhân viên">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Số lượng nhân viên</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.extraInfo.numberOfStaff"
                    type="number"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="cashier" name="Người thu ngân">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Người thu ngân</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.cashier"
                    :options="systemConfig.cashier"
                    placeholder="Người thu ngân"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="cashier" name="Tình trạng biển hiệu">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Tình trạng biển hiệu</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.bannerState"
                    :options="systemConfig.bannerState"
                    placeholder="Tình trạng biển hiệu"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <div class="form">
            <ValidationProvider vid="mcc" name="Đã biết MPOS?">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Đã biết MPOS?</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.knowMPOS"
                    :options="systemConfig.knowMPOS"
                    placeholder="Đã biết MPOS?"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="" vid="suggestServiceList" name="Dịch vụ quan tâm">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Dịch vụ quan tâm</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataAdd.suggestServiceList"
                    :options="systemConfig.services"
                    placeholder="Dịch vụ quan tâm"
                    :class="{
                      'invalid-form':
                        dataAdd.suggestServiceList === '' || dataAdd.suggestServiceList === null,
                    }"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="lstPaymentMethodSuggest" name="PT Thanh toán quan tâm">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">PT Thanh toán quan tâm</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataAdd.extraInfo.lstPaymentMethodSuggest"
                    :options="systemConfig.paymentMethod"
                    placeholder="PT Thanh toán quan tâm"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div class="form">
            <ValidationProvider vid="mcc" name="Đã có POS">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Đã có POS</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.ownPOS"
                    :options="systemConfig.ownPOS"
                    placeholder="Đã có POS"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="lstPos" name="POS bên nào">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">POS bên nào</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataAdd.extraInfo.lstPos"
                    :options="systemConfig.posBank"
                    placeholder="POS bên nào"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="dataAdd.extraInfo.lstPos && dataAdd.extraInfo.lstPos.includes('OTHER')"
              vid="numberOfShop"
              name="POS bên nào(Ghi chú thêm)"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">POS bên nào(Ghi chú thêm)</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.extraInfo.posOther"
                    placeholder="POS bên nào(Ghi chú thêm)"
                    type="text"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div class="form">
            <ValidationProvider vid="hasVietQr" name="Đã có VietQR">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Đã có VietQR</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.hasVietQr"
                    :options="systemConfig.hasVietQr"
                    placeholder="Đã có VietQR"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="lstVietQrBank" name="VietQR bên nào">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">VietQR bên nào</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataAdd.extraInfo.lstVietQrBank"
                    :options="systemConfig.vietQrBank"
                    placeholder="VietQR bên nào"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="
                dataAdd.extraInfo.lstVietQrBank && dataAdd.extraInfo.lstVietQrBank.includes('OTHER')
              "
              vid="vietQrBankOther"
              name="VietQR bên nào(Ghi chú thêm)"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">VietQR bên nào(Ghi chú thêm)</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.extraInfo.vietQrBankOther"
                    placeholder="VietQR bên nào(Ghi chú thêm)"
                    type="text"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div class="form">
            <ValidationProvider vid="hasInstallment" name="Đã có Trả góp">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Đã có Trả góp</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.hasInstallment"
                    :options="systemConfig.hasInstallment"
                    placeholder="Đã có Trả góp"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="lstInstallmentBank" name="Trả góp bên nào">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Trả góp bên nào</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataAdd.extraInfo.lstInstallmentBank"
                    :options="systemConfig.installmentBank"
                    placeholder="Trả góp bên nào"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="
                dataAdd.extraInfo.lstInstallmentBank &&
                dataAdd.extraInfo.lstInstallmentBank.includes('OTHER')
              "
              vid="installmentBankOther"
              name="Trả góp bên nào(Ghi chú thêm)"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Trả góp bên nào(Ghi chú thêm)</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.extraInfo.installmentBankOther"
                    placeholder="Trả góp bên nào(Ghi chú thêm)"
                    type="text"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div class="form">
            <ValidationProvider vid="softwareUseState" name="Tình trạng dùng PM quản lý">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Tình trạng dùng PM quản lý</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.softwareUseState"
                    :options="systemConfig.softwareUseState"
                    placeholder="Tình trạng dùng PM quản lý"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="storeManagementSoftware" name="PM quản lý cửa hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">PM quản lý cửa hàng</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataAdd.extraInfo.storeManagementSoftware"
                    :options="systemConfig.storeManagementSoftware"
                    placeholder="PM quản lý cửa hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="
                dataAdd.extraInfo.storeManagementSoftware &&
                dataAdd.extraInfo.storeManagementSoftware.includes('OTHER')
              "
              vid="installmentBankOther"
              name="PM quản lý bên nào(Ghi chú thêm)"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">PM quản lý bên nào(Ghi chú thêm)</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.extraInfo.storeManagementSoftwareOther"
                    placeholder="PM quản lý bên nào(Ghi chú thêm)"
                    type="text"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <div class="form-group row">
            <label for class="col-sm-3 col-form-label">Kênh tạo</label>
            <div class="col-sm-7">
              <Select2
                v-model="dataAdd.dataSource"
                :options="systemConfig.leadDataSource"
                placeholder="Kênh tạo"
              />
            </div>
          </div>

          <div class="form-group row">
            <label for class="col-sm-3 col-form-label">Nguồn tạo</label>
            <div class="col-sm-7">
              <Select2
                v-model="dataAdd.channel"
                :options="dataReferSource"
                placeholder="Nguồn tạo"
              />
            </div>
          </div>
          <div class="form-group row" v-if="dataAdd?.channel === 'AGENCY'">
            <label for class="col-sm-3 col-form-label">Chọn cộng tác viên</label>
            <div class="col-sm-7">
              <Select2
                v-model="agentInfo.agentId"
                :options="agentInfo?.defaultAgent || []"
                @change="getInforAgent"
                :settings="searchAgent"
                placeholder="Tìm kiếm cộng tác viện"
              />
            </div>
          </div>
          <div class="form-group row">
            <label for class="col-sm-3 col-form-label">Ghi chú</label>
            <div class="col-sm-7">
              <input
                v-model="dataAdd.description"
                type="text"
                class="form-control"
                placeholder="Ghi chú"
              />
            </div>
          </div>
        </form>

        <form class="col-md-6">
          <div class="img-list-wrapper">
            <h1 class="form-inner-heading mb-1">Ảnh</h1>
            <div class="form-group row img-list">
              <ul v-viewer>
                <li v-for="(itemImg, index) in dataUploadImage" :key="index">
                  <a href="#popup-slider" data-toggle="modal">
                    <img :src="itemImg" alt="" />
                  </a>
                </li>
                <li>
                  <div @click="showAddImages()" class="add-img btn">
                    <span class="bx bx-plus text-center"></span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>

    <!-- Modal thông báo -->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <div v-if="showModalNoti">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalNoti = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img :src="srcImage" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="checkToActionModal(keyCheck)"
                    data-dismiss="modal"
                    v-if="keyCheck === 'accept' || keyCheck === 'back' || keyCheck === 'addLead'"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalNoti = false"
                    data-dismiss="modal"
                    v-if="keyCheck === 'cancel' || keyCheck === 'back'"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <addLeadsImage
      :showModalAddImage="showModalAddImage"
      :dataLeads="dataAdd"
      :dataUploadImage="dataUploadImage"
      @submitAddImage="addLeadImages"
      @close="closeAddImages()"
    >
    </addLeadsImage>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { LeadsService } from '@/services/lead.service'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import { StaffService } from '@/services/staff.service'
  import leadsImage from './modal-leads/add-image.vue'
  import Config from '@/thirdParty/config'
  import merchantMx from '../../mixins/merchantMx'
  import { AgentService } from '@/services/agent.service'

  export default {
    data() {
      return {
        dataAdd: {
          uploadImages: [],
          extraInfo: {
            licenseBusiness: '',
            storeLocation: '',
            averageOrder: '',
            averageAge: '',
            knowMPOS: '',
            ownPOS: '',
          },
        },
        agentInfo: {
          agentId: '',
          listSoft: [],
          payload: {},
          defaultAgent: [],
        },
        searchAgent: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }
              const keySearch = txtSearch ?? ''
              if (this.tLoadOwner) {
                clearTimeout(this.tLoadOwner)
              }
              this.tLoadOwner = setTimeout(() => {
                AgentService.getListAgent({
                  name: keySearch,
                  page: 1,
                  limit: 10,
                }) // AI
                  .then(res => {
                    success({
                      results:
                        res.data?.map(item => {
                          return {
                            id: item?.agentId,
                            text: item.name || '',
                          }
                        }) || [],
                    })
                    this.agentInfo.listSoft = res.data
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
        leadId: this.$route.params.leadId,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataConfigRegion: [],
        search: {
          limit: 50,
          page: 1,
        },
        loading: false,
        pagination: {
          total: 0,
        },
        messSuccess: '',
        messErr: '',
        dataContractOrigin: [],
        dataProvince: [],
        dataDistrict: [],
        showModalAddImage: false,
        dataUploadImage: [],
        showModalNoti: false,
        messNoti: '',
        srcImage: '',
        keyCheck: '',

        dataReferSource: Config.sourceCreate,
        dataSource: [
          { id: 'ZALO', text: 'Zalo' },
          { id: 'HOTLINE', text: 'Hotline' },
          { id: 'GOOGLE', text: 'Google' },
          { id: 'COLLECT', text: 'Thu thập' },
          { id: 'OTHER', text: 'Khác' },
          { id: 'FACEBOOK', text: 'Facebook' },
          { id: 'TIKTOK', text: 'TikTok' },
        ],
        notiModal: false,
        iconNoti: '',
        msgNoti: '',
        dataCustomerType: [
          { id: 'COMPANY', text: 'Doanh nghiệp' },
          { id: 'HOUSEHOLD', text: 'Hộ kinh doanh' },
          { id: 'INDIVIDUAL', text: 'Cá nhân' },
        ],
        showLoading: false,
      }
    },

    mixins: [prepareQueryParamsMixin, merchantMx],

    components: {
      addLeadsImage: leadsImage,
    },

    created() {
      this.getProvince()
      this.getDistictByCode()
      this.fetchData()
      this.getConfigSystem()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
    },

    methods: {
      async checkCloseAdd() {
        this.keyCheck = 'back'
        this.showErr('Bạn có chắc chắn muốn huỷ bỏ thao tác không ?')
      },
      getInforAgent(id) {
        const sort = this.agentInfo.listSoft.find(item => item.agentId === id)

        this.agentInfo.payload = {
          agentGroup: sort.agentGroupCode,
          agentId: id,
          agentEmail: sort.email,
          agentName: sort.name,
          agentMobile: sort.mobile,
        }
      },

      async closeAdd() {
        this.$router.push('/leads')
      },

      async fetchData() {
        try {
          this.showLoading = true
          const response = await LeadsService.detailLead({
            leadId: this.leadId,
          })
          if (response.code === 1000 || response.success) {
            this.dataAdd = response.data
            const data = []
            response.data &&
              response.data.suggestServiceList &&
              response.data.suggestServiceList.map(e => {
                data.push(e.serviceType)
              })
            this.dataAdd.suggestServiceList = data

            if (response.data.extraInfo === null) {
              this.dataAdd.extraInfo = {
                licenseBusiness: null,
                storeLocation: null,
                averageOrder: null,
                averageAge: null,
                knowMPOS: null,
                ownPOS: null,
              }
            }
            this.dataUploadImage = this.dataAdd.uploadImages.length ? this.dataAdd.uploadImages : []

            this.agentInfo.agentId = response.data.agentId
            this.agentInfo.defaultAgent = [
              {
                id: response.data?.agentId || '',
                text: response.data?.agentName || '',
              },
            ]
            this.agentInfo.payload = {
              agentGroup: response.data.agentGroupCode || '',
              agentId: response.data.agentId || '',
              agentEmail: response.data.agentEmail || '',
              agentName: response.data.agentName || '',
              agentMobile: response.data.agentMobile || '',
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async updateLead(isAllow) {
        try {
          this.showLoading = true
          if (isAllow) this.dataAdd.allowSave = true
          else delete this.dataAdd.allowSave

          if (this.dataAdd.districtCode === '0') {
            delete this.dataAdd.districtCode
            delete this.dataAdd.district
          }
          if (this.dataAdd.mcc === '0') delete this.dataAdd.mcc

          const isSuccess = await this.$refs.leadsEdit.validate()
          if (!isSuccess) {
            this.keyCheck = 'cancel'
            this.showErr('Vui lòng điền đúng thông tin !')
            return
          }

          if (this.agentInfo.payload.agentId) {
            this.dataAdd = { ...this.dataAdd, ...this.agentInfo.payload }
          }

          const response = await LeadsService.updateLead(this.dataAdd)
          if (response.code === 1000) {
            this.showModalNoti = true
            this.messNoti = 'Cập nhật Lead thành công !'
            this.keyCheck = 'accept'
            this.srcImage = require('@/assets/img/noti-success2.svg')
          } else if (response.code === 1025 || response.code === 1039 || response.code === 1042) {
            this.notiModal = true
            this.msgNoti = response.message
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          } else {
            this.keyCheck = 'cancel'
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      showErr(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-unsuccess2.svg')
      },

      async convertIntoCustomer(isAllow) {
        try {
          const serviceList = []
          if (this.dataAdd.suggestServiceList && this.dataAdd.suggestServiceList.length) {
            this.dataAdd.suggestServiceList.map(e => {
              if (e.serviceType && e.serviceType !== null) serviceList.push(e.serviceType)
              else delete this.dataAdd.suggestServiceList
            })
          }

          if (serviceList.length !== 0) this.dataAdd.suggestServiceList = serviceList

          if (isAllow) this.dataAdd.allowSave = true
          else delete this.dataAdd.allowSave

          if (this.dataAdd.mcc === '0') delete this.dataAdd.mcc

          if (this.dataAdd.districtCode === '0') {
            delete this.dataAdd.districtCode
            delete this.dataAdd.district
          }

          const isSuccess = await this.$refs.leadsEdit.validate()
          if (!isSuccess) {
            this.keyCheck = 'cancel'
            this.showErr('Vui lòng điền đúng thông tin !')
            return
          }
          if (this.agentInfo.payload.agentId) {
            this.dataAdd = { ...this.dataAdd, ...this.agentInfo.payload }
          }
          const response = await LeadsService.updateLead(this.dataAdd)
          if (response.code === 1000) {
            if (this.dataAdd.status === 'VERIFIED') {
              this.$router.push(`/auth-info/${this.dataAdd.leadId}/auth`)
            } else {
              this.$router.push({ path: `/detail-lead/${this.dataAdd.leadId}/addActionFromOther` })
            }
          } else {
            this.keyCheck = 'cancel'
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        }
      },

      async getProvince() {
        try {
          this.showLoading = true
          const data = await StaffService.getAllCity({})
          if (data.data.length > 0) {
            data.data.forEach(e => {
              this.dataProvince.push({
                id: e.code,
                text: e.name,
              })
            })
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      async getDistictByCode() {
        try {
          this.showLoading = true
          this.dataDistrict = []
          const data = await StaffService.getDistictByCode({})
          if (data.data.length > 0) {
            const dataDistrict = [{ id: '0', text: '-- -- --' }]
            data.data.map(e => {
              dataDistrict.push({ id: e.code, text: e.name })
            })
            this.dataDistrict = dataDistrict
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      getNameProvince(item) {
        this.dataAdd.city = item.text
      },
      getNameDistrict(item) {
        this.dataAdd.district = item.text
      },

      showAddImages() {
        this.showModalAddImage = true
      },
      closeAddImages() {
        this.showModalAddImage = false
        this.dataAdd.uploadImages = this.dataUploadImage
      },
      addLeadImages(dataImages) {
        this.dataAdd.uploadImages = this.dataUploadImage = dataImages
      },
      checkToActionModal(keyCheck) {
        if (keyCheck === 'accept' || keyCheck === 'back') {
          this.showModalNoti = false
          this.closeAdd()
        }
        if (keyCheck === 'addLead') {
          this.showModalNoti = false
          this.updateLead(true)
        }
      },
    },
  }
</script>

<style scoped>
  .placeholder {
    background: #f0f0f0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-family: Helvetica;
  }

  .placeholder:hover {
    background: #e0e0e0;
  }

  .form {
    border-bottom: 1px solid #bbbbbb;
    margin-bottom: 1rem;
  }
</style>
